const reviewArticleStyle = Object.freeze({});

export default reviewArticleStyle;
